import { NANO_SECOND_IN_MS, SECOND_IN_MS } from './timeConstants';
/** converts the TimeInNanos to milliseconds */
const toTimestamp = (time) => (time &&
    Math.floor((time.timeInSeconds || 0) * SECOND_IN_MS +
        (time.offsetInNanos || 0) * NANO_SECOND_IN_MS)) ||
    0;
/**
 * Extracts the value out of a SiteWise Model Variant
 *
 * SiteWise Model values can either be a string, number or boolean.
 *
 * NOTE: Currently we treat booleans as strings.
 */
export const toValue = (variant) => {
    if (variant == null) {
        throw new Error('variant is undefined');
    }
    const { doubleValue, integerValue, stringValue, booleanValue } = variant;
    if (doubleValue != null) {
        return doubleValue;
    }
    if (integerValue != null) {
        return integerValue;
    }
    if (stringValue != null) {
        return stringValue;
    }
    if (booleanValue != null) {
        return booleanValue.toString();
    }
    throw new Error('Expected value to have at least one property value, but instead it has none!');
};
/**
 * Converts a SiteWise response for data into a data point understood by IoT App Kit.
 */
export const toDataPoint = (assetPropertyValue) => {
    if (assetPropertyValue == null) {
        return undefined;
    }
    const { timestamp, value, quality } = assetPropertyValue;
    const dataValue = toValue(value);
    if (dataValue == null) {
        return undefined;
    }
    return {
        x: toTimestamp(timestamp),
        y: dataValue,
        quality,
    };
};
// TODO: support outputting multiple sets of DataStream for multiple aggregate types.
const aggregateToValue = ({ average, count, maximum, minimum, sum, standardDeviation, }) => {
    if (average != null) {
        return average;
    }
    if (count != null) {
        return count;
    }
    if (maximum != null) {
        return maximum;
    }
    if (minimum != null) {
        return minimum;
    }
    if (sum != null) {
        return sum;
    }
    if (standardDeviation != null) {
        return standardDeviation;
    }
    throw new Error('Expected there to be a valid aggregate contained in `Aggregates`');
};
/**
 * AggregatedValue currently might not return timestamp according to the typescript AggregatedValue interface
 */
const getAggregateTimestamp = (timestamp) => {
    if (timestamp instanceof Date) {
        return timestamp.getTime();
    }
    throw new Error('Expected timestamp to be instance of Date');
};
/**
 * Aggregates To Data Point
 *
 * Converts an `AggregatedValue` to the data point view model
 */
export const aggregateToDataPoint = ({ timestamp, value, quality, }) => ({
    x: getAggregateTimestamp(timestamp),
    y: aggregateToValue(value),
    quality,
});
